export class SessionDetails {
  constructor(module) {
    this.module = module;
  }

  close() {
    this.module.target.classList.remove("sessions__target--active");
    this.module.container.classList.remove("sessions--active");
    this.module.sidebar.classList.remove("sessions__sidebar--active");

    Array.from(this.module.sessions).forEach((session) =>
      session.classList.remove("session--active")
    );

    this.module.target.style.height = null;
    this.module.target.innerHTML = "";
  }

  setActive(item) {
    this.module.target.style.height = null;

    const sessionCollapsedContent = this.module.target.querySelector(
      ".session__collapsed-content"
    );

    setTimeout(() => {
      if (
        sessionCollapsedContent &&
        sessionCollapsedContent.parentNode === this.module.target
      )
        this.module.target.removeChild(sessionCollapsedContent);
    }, 300);

    if (item.classList.contains("session--active")) {
      item.classList.remove("session--active");
      this.module.target.classList.remove("sessions__target--active");
      this.module.container.classList.remove("sessions--active");

      return;
    }

    const isFirstOpening =
      this.module.sessionBlock.querySelectorAll(".session--active").length ===
      0;

    this.module.container.classList.add("sessions--active");
    this.module.sidebar.classList.add("sessions__sidebar--active");

    const content = item.querySelector(".session__collapsed-content");

    Array.from(this.module.sessions).forEach((session) =>
      session.classList.remove("session--active")
    );

    item.classList.add("session--active");

    const header = document.querySelector(".main-navigation-container");
    content.style.top = header.offsetHeight + 10 + "px";

    this.module.target.innerHTML = content.outerHTML;
    this.module.target.classList.add("sessions__target--active");

    if (isFirstOpening) {
      this.module.target.addEventListener(
        "transitionend",
        () => {
          this.setTargetHeight(header);
          this.scroll(item, header);
        },
        { once: true }
      );
    } else {
      this.setTargetHeight(header);
      this.scroll(item, header);
    }
  }

  setTargetHeight(header) {
    const targetContent = this.module.target.querySelector(
      ".session__collapsed-content"
    );
    targetContent.style.maxHeight = `calc(100vh - ${
      header.offsetHeight + 30
    }px)`;

    const itemsHeight = Array.from(this.module.sessions).reduce(
      (acc, session) => {
        const imageHeight = session.querySelector(".session__preview-image")
          ? Number(
              session.querySelector(".session__preview-image").style.height
            )
          : 0;
        const itemHeight = session.offsetHeight + imageHeight;
        if (session.nextElementSibling) return acc + itemHeight + 20;
        return acc + itemHeight;
      },
      0
    );

    const targetHeight = targetContent.offsetHeight;
    const targetImageHeight = document.querySelector(".session__image")
      ? Number(document.querySelector(".session__image").style.height)
      : 0;
    const totalTargetHeight = targetHeight + targetImageHeight;
    this.module.target.style.height = totalTargetHeight + itemsHeight + "px";
  }

  scroll(item, header) {
    const itemPosition =
      item.getBoundingClientRect().top + window.scrollY - header.offsetHeight;
    window.scrollTo({ top: itemPosition - 10, behavior: "smooth" });
  }
}
